export const BUSINESS_START_YEAR = '235e815aa992800107cd61e8a855cbb4181e8213';
export const OPERATIONAL_STATES = 'bd14cb884a9568aa74c27da5524378ba38be5c5c';
export const SIZE_OF_BUSINESS = '97a1a50a7a9414d7edcf6d2d9fb59c19d4312913';
export const BUSINESS_CATEGORIES = 'e31fb4ccbf4a9adb4b1b59e623041d47253339f2';
export const BUSINESS_SUB_CATEGORIES = '1bf8a924fdb6f21f3b4dc2f6ba6741c783dc25ac';
export const BUSINESS_CHILD_CATEGORIES = '13e986915ebe365a29a1579585a5ae9da1a12bd1';
export const USER_ID = 'ff325b8b93d5c5375dbcee7eeacb318277c7006f';
export const PROFILE_URL = '63ba442ae5903086fda2516e8427855e8f3c4d6f';
export const NUMBER_OF_PROJECTS = '4755912da82f14292354a4e02ecfaf2db16bd204';
export const ACTIVE_TIER = '6a11bc807156e807fa39ba07de7d9c13a1de9248';
export const COMPANY_LOCATION = '28650c26124ee1da459d7a2232d6e9ce09a707ba';
export const WEBSITE = 'a7c418253d84845f47d5b4f60392742f5c6890de';
export const BUSINESS_NAME = 'f26f06b72016fa597a142a7f0e4a6524fc5ced9f';

export const OWNER_EMAIL = '0ff7d7fc58fb72a0959321bfc5e363ec5fe1fd12';
export const OWNER_COMPANY = '1971b0195dc8ec6881d03d298358c0712a79e6f1';
export const PROJECT_STATES = '8be0e29c4bcdbc213b2bec37bc08ddb72ebc779f';
export const PROJECT_PRIME_CATEGORIES = '3b3c6f897275fd8597a754a6db762d23ef006dc6';
export const PROJECT_SUB_CATEGORIES = 'eeacc90ff8b5e52367d6b7ca417d67240d7dec1e';
export const PROJECT_CHILD_CATEGORIES = '226a15cca9fe747b181620c43872b78b9bb6b553';
export const NUMBER_OF_FEET = '9b37b1d91945f96a4b096500ec0b12fda3f71064';
export const PROJECT_BUDGET = 'b8bcb8df9eb22196e8cc96b3d5b2d24960095da5';
export const BIDDER_EMAIL = '3276f4a424c7bf4d578507251b234476f8e47279';
export const BIDDER_COMPANY = '1cbbb8a05b02a061cc5f6edac472dac27b112b20';
export const BIDDER_BID = '870d49efa73cf1b652de0f100cf4aea53687c882';
export const BID_SUBMISSION_DATE = '3179193687841a5dca8236a397d6c90f3f45b57b';
export const BID_MADE = '3082e5a8bd777615035198c5781fcf6602308c7e';
export const PUBLISHED_AT = '0a239a95d493b0d6baecffd3cefe8dae4db4947e';